'use es6';

import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { ELEMENT, ELEMENT_PLACEHOLDER } from 'LayoutBuilderUI/lib/DragDropConstants';
import { DropTarget } from 'react-dnd-compat';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { NativeTypes } from 'react-dnd-ipeui-backend';
import { dropNewImageElement } from 'LayoutBuilderUI/actions/layoutActions';
import { getIsFileManagerOpen } from 'LayoutBuilderUI/selectors/userInterface';
import { compose } from 'redux';
import GrayScaleWhenHidden from 'LayoutBuilderUI/components/overlays/GrayScaleWhenHidden';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import { View } from 'foundations-components/transitional/components/View';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { jsx as _jsx } from "react/jsx-runtime";
const widgetDragTarget = {
  drop(props, monitor) {
    const itemType = monitor.getItemType();
    const {
      sectionId,
      columnId
    } = props;
    // See the endDrag handler in the draggable component - this avoids a race condition that keeps the UI from knowing that the drop has occurred
    // More info: https://github.com/gaearon/react-dnd/issues/455
    const dropProps = {
      type: ELEMENT_PLACEHOLDER,
      sectionId,
      columnId
    };
    if (itemType === NativeTypes.FILE) {
      const item = monitor.getItem();
      const file = item.files && item.files.length ? item.files[0] : null;
      if (file) {
        props.dropNewImageElement(Object.assign({}, dropProps, {
          file
        }));
      }
      return undefined;
    }
    return dropProps;
  },
  canDrop: props => !props.isFileManagerOpen
};
class Placeholder extends Component {
  onPlaceholderClick(e) {
    e.stopPropagation();
  }
  render() {
    const {
      connectDropTarget,
      isOver,
      canDrop
    } = this.props;
    const isActive = canDrop && isOver;
    const placeholderContent = connectDropTarget( /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(DropZone, {
        use: isActive ? 'hover' : undefined,
        size: "small",
        children: /*#__PURE__*/_jsx(View, {
          margin: "-300",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "layoutBuilder.placeholders.content"
          })
        })
      })
    }));
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      // @bend-expect trellis-tokenized
      _jsx("div", {
        className: "hs_cos_wrapper_widget hs_cos_wrapper_widget_placeholder",
        "data-test-id": "widget_placeholder",
        children: /*#__PURE__*/_jsx(NamespaceWrapper, {
          children: /*#__PURE__*/_jsx(GrayScaleWhenHidden, {
            children: placeholderContent
          })
        })
      })
    );
  }
}
Placeholder.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired
};
export default compose(connect(state => ({
  isFileManagerOpen: getIsFileManagerOpen(state)
}), {
  dropNewImageElement
}), DropTarget([ELEMENT, NativeTypes.FILE], widgetDragTarget, monitor => ({
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
})))(Placeholder);